<div class="info-claims">
  <h3>{{ 'contract-claims-list.claims-info-title'|translate }}</h3>
  <ng-container *ngIf="claims && claims.length">
    <div class="info-claims-list" *ngFor="let claim of claims">
      <div class="info claim">
        <div>
          <label>{{ 'contract-claims-list.identifier' | translate }}</label>
          <p>{{ claim.identifier }}</p>
        </div>
        <div>
          <label>{{ 'contract-claims-list.claim-date' | translate }}</label>
          <p>{{ dateToString(claim.claim_date) }}</p>
        </div>
        <div>
          <label>{{ 'contract-claims-list.type' | translate }}</label>
          <p>{{ claim.type }}</p>
        </div>
        <div>
          <label>{{ 'contract-claims-list.cause' | translate }}</label>
          <p>{{ claim.cause }}</p>
        </div>
        <div>
          <label>{{ 'contract-claims-list.status' | translate }}</label>
          <p>{{ claim.status }}</p>
        </div>
      </div>
      <div class="actions">
        <button mat-raised-button color="primary" (click)="selectClaim(claim.identifier)">Select</button>
      </div>
    </div>
  </ng-container>
</div>
